import { LogEntry } from './dtos/LogEntry.schema.d'
import axios from 'axios'
import { LogEventType } from './dtos/LogEventType.schema'
import { logEntryToGerman } from '@/misc/i18n'

export const getLog = async (
  start: Date,
  end: Date,
  stationIds: string[] | undefined = undefined,
  eventTypes: LogEventType[] | undefined = undefined,
  logLevel: number | undefined = undefined,
  operatorIds: string[] | undefined = undefined
): Promise<LogEntry[]> => {
  const res = await axios.get<LogEntry[]>('/log', {
    params: {
      start: start.toISOString(),
      end: end.toISOString(),
      stations: stationIds?.join(',') ?? undefined,
      eventTypes: eventTypes?.join(',') ?? undefined,
      logLevel: logLevel,
      operators: operatorIds?.join(',') ?? undefined
    }
  })

  return res.data
}

export const postLogs = async (
  logs: LogEntry[]
): Promise<LogEntry[]> => {
  const res = await axios.post<LogEntry[]>('/log', logs)
  return res.data
}
